import { appendEvent, appendMessage } from './awsWidgetEvents';
import { connectWebSocket, disconnectWebSocket } from './websocketClient';

function _sendMessage(container) {
  const input = container.querySelector('.aws-chatkit-composer-input');
  const sendBtn = container.querySelector('.aws-chatkit-send-btn');
  const text = input.value.trim();
  if (!text) return;

  // TODO: This dummy behavior will be replaced with the actual live agent behavior
  appendMessage(container, 'customer', text, 'You');
  appendMessage(container, 'agent', "Wait a moment, please. I'll check your request", 'Live Agent');

  input.value = '';
  input.style.height = '';
  sendBtn.disabled = true;
}

function _bindComposer(container) {
  const input = container.querySelector('.aws-chatkit-composer-input');
  const sendBtn = container.querySelector('.aws-chatkit-send-btn');
  if (!input || !sendBtn) return;

  input.addEventListener('input', () => {
    input.style.height = 'auto';
    input.style.height = `${Math.min(input.scrollHeight, 96)}px`;
    sendBtn.disabled = !input.value.trim();
  });

  sendBtn.addEventListener('click', () => _sendMessage(container));

  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      _sendMessage(container);
    }
  });
}

export function initializeAWSWidget(container, liveAgentData) {
  _bindComposer(container);
  appendEvent(container, 'Connecting to a live agent...');

  if (!liveAgentData) return;

  const { websocket_url: websocketUrl } = liveAgentData;
  connectWebSocket(container, websocketUrl);
}

export function destroyAWSWidget() {
  disconnectWebSocket();
}
